import {
  Chart as ChartJS,
  ArcElement,
  Tooltip
} from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { Card } from "react-bootstrap";
import React from "react";

ChartJS.register(ArcElement, Tooltip);



function ChargesChart({ chargesData }) {

  const centerText = {
    id: "centerText",
    beforeDraw(chart) {
      const { width, height, ctx } = chart;

      const total =
      chart.options.plugins.centerText?.total || 0;

      ctx.save(); // ✅ IMPORTANT

      const fontSize = height / 140;

      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      // MAIN TEXT
      ctx.font = `600 ${fontSize}em sans-serif`;
      ctx.fillStyle = "#111827";
      ctx.fillText(`$${total.toFixed(2)}`, width / 2, height / 2 - 10);

      // SUB TEXT
      ctx.font = `400 ${fontSize * 0.6}em sans-serif`;
      ctx.fillStyle = "#6b7280";
      ctx.fillText("Total", width / 2, height / 2 + 15);

      ctx.restore(); // ✅ AFTER drawing
    }
  };

  const chartData = {
    labels: chargesData?.categories?.map((item) => item?.name) || [
      "Parking Fees",
      "Add-Ons & Services",
      "Membership",
      "Other Fees",
      "Taxes"
    ],
    datasets: [
      {
        data: chargesData?.categories?.map((item) => item?.percentage) || [2500, 650, 350, 200, 150],
        backgroundColor: [
          "#2563eb",
          "#22c55e",
          "#a855f7",
          "#f59e0b",
          "#06b6d4"
        ],
        borderWidth: 0
      }
    ]
  };

  const options = {
    cutout: "70%",
    plugins: {
      legend: { display: false },
      centerText: {
      total: chargesData?.total || 0,
    },
    }
  };


  return (
    <Card className="charges-card">

      {/* TITLE */}
      <h6 className="mb-3">Charges by Category</h6>

      <div className="charges-body">

        {/* LEFT CHART */}
        <div className="chart">
          <Doughnut
            data={chartData}
            options={options}
            plugins={[centerText]}
          />
        </div>

        {/* RIGHT LEGEND */}
        <div className="legend">
          {chargesData?.categories?.map((item, i) => (
            <div className="legend-row" key={i}>

              <div className="left">
                <span
                  className="dot"
                  style={{ background: item.color }}
                ></span>
                {item?.name || ""}
              </div>

              <div className="right">
                <span>${item?.amount || "0"}</span>
                <span className="percent">{item?.percentage ? (item?.percentage).toFixed(2) : "0"}%</span>
              </div>

            </div>
          ))}
        </div>

      </div>

      {/* BUTTON */}
      {/* <button className="breakdown-btn">
        View Detailed Breakdown
      </button> */}

    </Card>
  );
}

export default React.memo(ChargesChart);